import styled from 'styled-components';

export const Container = styled.main`
  background-image: url(/icons/gado-bg.jpg);
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FormCard = styled.form`
  padding: 2rem 0;
  padding-top: 3rem;
  display: flex;
  height: 37rem;
  width: 30rem;
  border-radius: 15px;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  background-color: var(--white-bg);
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  > img {
    width: 10rem;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;

export const Title = styled.h2``;
